












































































































































import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import { parse } from 'date-fns'
import Candidate from '@/evaluations/entities/candidate'

@Component
export default class CandidateForm extends Vue {
  @Prop()
  private value!: Candidate

  private model = this.value

  @Watch('value')
  private valueUpdated(val: Candidate, old: Candidate) {
    this.model = val
  }

  private calulateAge(dateOfBirth: string) {
    var today = new Date()
    var birthDate = parse(dateOfBirth, 'dd.MM.yyyy', today)
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    this.model.age = age
  }
}
